import firebase from "firebase";
import 'firebase/firestore'
//import 'firebase/storage'


// Initialize Firebase
const config = {
  apiKey: "AIzaSyAqXCfhHS0iIJame3bh7ySrcrrq596k4jc",
  authDomain: "pos-ak-e234c.firebaseapp.com",
  projectId: "pos-ak-e234c",
  storageBucket: "pos-ak-e234c.appspot.com",
  messagingSenderId: "542416979385",
  appId: "1:542416979385:web:cc1a5ce7a138e8a7886268"
};
// Initialize Firebase


const firebaseApp = firebase.initializeApp(config);
firebaseApp.firestore().settings({ timestampsInSnapshots:true})

export default firebaseApp.firestore()



// WEBPACK FOOTER //
// ./src/firebase/init.js